import { Voter } from "@activecollab/security";

export class NoteVoter extends Voter {
  attributes = ["edit"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "Note";
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "edit": {
        if (user.class === "Client") {
          return !subject.is_hidden_from_clients;
        }
        return true;
      }
    }
    throw new Error("This code should not be reached!");
  }
}
